/**
 * Custom hook to trigger/handle query params changes
 *
 */

import { useState, useEffect } from "react";
const fromEntries = (entries) => {
  let res = {};
  for (let i = 0; i < entries.length; i++) res[entries[i][0]] = entries[i][1];
  return res;
};

const useQueryParams = () => {
  const [params, setParams] = useState({});

  if (typeof window === "undefined") return {};

  const routeParams = window.useParams?.() || {};
  const { search } = window.useLocation?.() || {};

  useEffect(() => {
    let searchObj = {};
    if (!Object.fromEntries) {
      searchObj = fromEntries(new URLSearchParams(search));
    } else {
      searchObj = Object.fromEntries(new URLSearchParams(search));
    }
    setParams({ ...searchObj, ...routeParams });
  }, [routeParams, search]);

  return params;
};

export default useQueryParams;
